// removed by extract-text-webpack-plugin
module.exports = {"sapcnqr-icon-button":"sapcnqr-icon-button-b69ba9","sapcnqr-icon-button--lg":"sapcnqr-icon-button--lg-4a3fde","sapcnqr-icon-button--wide":"sapcnqr-icon-button--wide-a3d931"};